import { Component, OnInit } from '@angular/core';
import { ConnectionService } from 'src/app/connection.service';
import * as Highcharts from 'highcharts';
import * as Exporting from 'highcharts/modules/exporting';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HttpParams } from '@angular/common/http';
import { SocketService } from 'src/app/services/socket.service';


@Component({
  selector: 'app-explorer',
  templateUrl: './explorer.component.html',
  styleUrls: ['./explorer.component.css']
})
export class ExplorerComponent implements OnInit {
  timeString: string = '';
  votechart: any
  blockDetails: any = {};
  Latestblock: any;
  blockseconds: any;
  cmsList: any = {};
  chartDatas: any;
  transactionList: any = {}
  myStyle: object = {}; myParams: object = {}; width: number = 100; height: number = 100;
  token_name: any
  chartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#000000' : '#ffffff';
  piechartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#2740a6' : '#2740a6';
  element: any;
  usersCount: any;
  accounts: any;
  dashboardDetails: any;
  totalTxns: any;
  totalAccounts: any;
  currentTPS: any;
  totalNodes: any;
  totalFrozen: any;
  transactionAccounts: any;
  transactionChartDatas: any;
  transactionUsersCount: any;
  transactionElement: any;
  depBlock: number = 1;
  depTransaction: number = 1;
  dep: number = 1
  trans: number = 1
  searchobj: any = {
    // searchAddress: ''
  }
  searchListDetails: any;
  token = localStorage.getItem('Sastana_Token')
  isSearch: boolean = false
  transactionInfo: any;
  tranStatus: any;
  sastanaPrice: any;
  marketCap: any;
  volume: any;
  srDetailsList: any;
  srCounts: any;
  nextRound: any;
  sum: number;
  YearlyAccount: any;
  monthlyAccount: number;
  YearlyTransaction: number;
  monthlyTransaction: number;
  dailyTransaction: number;
  dailyAccount: number;
  openCard: Boolean = false

  customOptions: OwlOptions = {
    autoplay: false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    nav: true,
    navText: ["<div class='nav-btn prev-slide'>  <img src='assets/img/arlf.svg'   ></div>", "<div class='nav-btn next-slide'><img src='assets/img/arrg.svg' ></div>"],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  }
  freezeAccounts: any[];
  listSR: any;
  nietos = []
  charts = [];

  defaultOptions = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    },
    title: {
      text: 'Real-time Block Distribution',
      style: {
        color: 'black',
      }
    },
    tooltip: {
      pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          style: {
            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
          }
        },
        showInLegend: true
      }
    },
    series: [{
      name: 'Brands',
      colorByPoint: true,
      data: ''
    }]
  }
  freezeDatas: any;
  freezeElement: any;
  freezeCount: any;
  SrElement: any;
  voCount: any;
  voteAccounts: any[];
  priceValue: any[];
  usersBalance: any;
  priceDatas: any;
  searchData: any;
  searchType: string;
  address: any;
  freezeaddress: string;
  sr: any;
  Srep: any;
  useraccounts: any;
  user_contract: any;
  contractName: any;
  voteaddress: string;

  constructor(
    private conn: ConnectionService, private router: Router,
    private alert: ToastrService, private socketService: SocketService
  ) {
    this.conn.themes.subscribe(resData => {
      setTimeout(() => {
        if (resData) {
          this.chartColor = (resData == 'darktheme') ? '#000000' : '#ffffff';
          this.piechartColor = (resData == 'darktheme') ? '#2740a6' : '#ffffff';
        }
      }, 4000);
    });
  }

  ngOnInit() {
    this.socketStake()
    this.getPriceDetails();
    this.getnextmaintenancetime()
    this.getCms()
    this.chartDetails("yearly")
    this.transactionchartDetails("yearly")
    this.freezechartDetails()
    this.getSR()
    this.sastPrice()
    this.SrInfo();
    this.activeTotalAccounts()

    setTimeout(() => {
      this.calculateTimeRemaining();
    }, 3000);
  }


  socketStake(): any {
    this.socketService.latestBlocks().subscribe((res: any) => {
      if (res == 'latestblocks') {
        this.blockHistoryDetails();
        this.latestBlockDetails()
        this.transactionHistory()
      }
    });
  }

  getSR() {
    this.conn.postUrl('users/srVoteChart', {}).subscribe((res: any) => {
      this.listSR = res.data;
      this.voteAccounts = []
      let categoriesData = []
      for (let index = 0; index < this.listSR.length; index++) {
        this.SrElement = this.listSR[index];
        this.voCount = this.SrElement.voteCount
        this.voteAccounts.push(this.voCount)
        this.voteaddress = this.listSR[index].address.slice(0, 3) + '..' + this.listSR[index].address.slice(30, 34)
        categoriesData.push(this.voteaddress)
        this.Srchart(categoriesData);
      }
    });
  }

  getTypeData(type: any, search: any) {
    if (type == 'transHash' || type == 'blockNumber' || type == 'token') {
      if (search?.length == 34) {
        this.openCard = false
      }
    }
    else {
      this.getSearchsuggestion(search, type)
    }
  }

  getSearchsuggestion(search: any, type: any) {
    if (search != '') {
      this.openCard = true;
      if (search?.length == 34) {
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res: any) => {
          if (!res.error && res.user) {
            this.searchType = 'Accounts'
            this.useraccounts = res.user[0]
            this.sr = ''
            this.searchData  = ''
          }
          else if (!res.error && res.sr) {
            this.searchType = 'SR'
            this.sr = res.sr[0]
            this.useraccounts = ''
          }
          else if (!res.error && res.usercontract) {
            this.searchType = 'Contracts'
            this.user_contract = res.usercontract[0]
            this.contractName = res.name
          }
          else {
            this.openCard = false
          }
        })
      }
      else if (search?.includes("http://")) {
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res: any) => {
          if (!res.error) {
            this.searchType = 'SR'
            this.Srep = res[0]
          }
          else {
            this.openCard = false
          }
        })
      }
      else {
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res: any) => {
          if (!res.error ) {
            this.searchData = res
            this.searchType = 'Tokens'
          }
          else {
            this.openCard = false
          }
        })
      }
    }
    else {
      this.openCard = false
    }
  }

  viewMoreVotesHolders() {
    this.router.navigate(['pages/network-chart'])
  }

  viewMoreAccounts() {
    this.router.navigate(['pages/account-chart'])
  }

  viewMoreTransactions() {
    this.router.navigate(['pages/transaction-chart'])
  }

  viewAllBlocks() {
    this.router.navigate(['/block'])
  }
  viewAllTransactions() {
    this.router.navigate(['/transaction-history'])
  }

  viewSuperRep() {
    this.router.navigate(['/representatives'])
  }

  getContractPage(address: any) {
    this.router.navigate(['/contract-read/', address])
  }

  getCms() {
    this.conn.getUrl('cms/find_cms').subscribe((res: any) => {
      if (res.status == true) {
        this.cmsList = res.data
      }
    })
  }
  chartDetails(charttype: any) {
    this.accounts = []
    this.conn.postUrl('users/account-growth', { type: charttype }).subscribe((chartres: any) => {
      this.chartDatas = chartres.data
      let categoriesData = []
      for (let index = 0; index < this.chartDatas.length; index++) {
        this.element = this.chartDatas[index];
        this.usersCount = this.element.usersCount
        this.accounts.push(this.usersCount)
        this.sum = 0
        if (charttype == 'yearly') {
          categoriesData.push(this.chartDatas[index].year)
          this.YearlyAccount = 35
        }
        else if (charttype == 'monthly') {
          categoriesData.push(this.chartDatas[index].monthInName)
          this.monthlyAccount = 5
        }
        else {
          this.dailyAccount = 2
          categoriesData.push(this.chartDatas[index].date)
        }
        if (index == this.chartDatas.length - 1) {
          this.chart(categoriesData);
        }
      }
    })
  }

  transactionchartDetails(type: any) {
    this.transactionAccounts = []
    this.conn.postUrl('users/transactionChart', { type: type }).subscribe((transactionChartRes: any) => {
      this.transactionChartDatas = transactionChartRes.data
      let categoriesData = []
      for (let index = 0; index < this.transactionChartDatas.length; index++) {
        this.transactionElement = this.transactionChartDatas[index];
        this.transactionUsersCount = this.transactionElement.usersCount
        this.transactionAccounts.push(this.transactionUsersCount)
        if (type == 'yearly') {
          this.YearlyTransaction = 21
          categoriesData.push(this.transactionChartDatas[index].year)
        }
        else if (type == 'monthly') {
          this.monthlyTransaction = 1
          categoriesData.push(this.transactionChartDatas[index].monthInName)
        }
        else {
          this.dailyTransaction = 0
          categoriesData.push(this.transactionChartDatas[index].date)
        }
        if (index == this.transactionChartDatas.length - 1) {
          this.transactionchart(categoriesData);
        }
      }
    })
  }

  freezechartDetails() {
    this.freezeAccounts = []
    this.conn.postUrl('users/freezeChart', {}).subscribe((freezeRes: any) => {
      this.freezeDatas = freezeRes.data
      let categoriesData = []
      for (let index = 0; index < this.freezeDatas.length; index++) {
        this.freezeElement = this.freezeDatas[index];
        this.freezeCount = this.freezeElement.freezeamount
        this.freezeAccounts.push(this.freezeCount)
        this.freezeaddress = this.freezeDatas[index].userAddress.slice(0, 3) + '..' + this.freezeDatas[index].userAddress.slice(30, 34)
        categoriesData.push(this.freezeaddress)
        if (index == this.freezeDatas.length - 1) {
          this.freezeChart(categoriesData);
        }
      }
    })
  }

  blockHistoryDetails() {
    this.conn.getUrl('users/latestblocks').subscribe((res: any) => {
      this.blockDetails = res.data
    })
  }

  transactionHistory() {
    this.conn.postUrl('users/transactionList', {}).subscribe((res: any) => {
      this.transactionList = res.data
    })
  }

  latestBlockDetails() {
    this.conn.postUrl('users/dashboard-data', {}).subscribe((res: any) => {
      this.dashboardDetails = res.data[0]
    })
  }

  activeTotalAccounts(){
		this.conn.postUrl('users/total-accounts', {}).subscribe((res: any) => {
			this.totalAccounts = res.data
		})
		
	}

  Srchart(category: any) {
    Highcharts.chart('sr_votes', {
      chart: {
        type: 'area'
      },
      accessibility: {
        description: '',
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: category
      },
      yAxis: {
        title: {
          text: ''
        },
      },
      tooltip: {
        pointFormat: '{series.name} <b>{point.y}</b><br/>',
        style: {
          backgroundColor: '#ffffff'
        }
      },
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
        // area: {
        //   marker: {
        //     enabled: false,
        //     symbol: 'circle',
        //     radius: 2,
        //     states: {
        //       hover: {
        //         enabled: true
        //       }
        //     }
        //   }
        // }
      },
      series: [{
        name: 'Votes',
        color: '#2740a6',
        data: this.voteAccounts
      }],
    } as any);
  }

  chart(category: any) {
    Highcharts.chart('account_growth', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y}</b></span>`,
        style: {
          backgroundColor: '#ffffff'
        }
      },
      series: [{
        name: 'Active Accounts',
        color: '#2740a6',
        data: this.accounts,
      }],
    } as any);
  }

  transactionchart(category: any) {
    Highcharts.chart('Transaction_chart', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y}</b></span>`,
        style: {
          backgroundColor: '#ffffff'
        }
      },
      series: [{
        name: 'Total Transactions',
        color: '#2740a6',
        data: this.transactionAccounts,
      }],
    } as any);
  }

  sastPrice() {
    this.priceValue = []
    this.conn.postUrl('users/priceChart', {}).subscribe((chartres: any) => {
      this.priceDatas = chartres.data
      let categoriesData = []
      for (let index = 0; index < this.priceDatas.length; index++) {
        this.element = this.priceDatas[index];
        this.usersBalance = this.element.balance
        this.priceValue.push(this.usersBalance)
        this.address = this.priceDatas[index].address.slice(0, 3) + '..' + this.priceDatas[index].address.slice(30, 34)
        categoriesData.push(this.address)
        this.sastHolders(categoriesData);
      }
    })
  }

  sastHolders(category: any) {
    Highcharts.chart('sast_holders', {
      chart: {
        type: 'area',
      },
      accessibility: {
        description: '',
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: category
      },
      yAxis: {
        title: {
          text: ''
        },
      },
      tooltip: {
        pointFormat: '{series.name} <b>{point.y}</b><br/>'
      },
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1
            }
          }
        }
        // series: {
        //   states: {
        //     hover: {
        //       enabled: false
        //     }
        //   }
        // }
        // area: {
        //   marker: {
        //     enabled: false,
        //     symbol: 'circle',
        //     radius: 2,
        //     states: {
        //       hover: {
        //         enabled: false
        //       }
        //     }
        //   }
        // }
      },
      series: [{
        name: 'SAST Holders',
        color: '#2740a6',
        data: this.priceValue
      }],
    } as any);
  }

  freezeChart(category: any) {
    Highcharts.chart('freeze_chart', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'column',
        width: 500,
        height: 370
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: category,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        }
      },
      tooltip: {
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        style: {
          backgroundColor: '#ffffff'
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{
        name: 'Total Frozen',
        type: 'column',
        color: '#2740a6',
        data: this.freezeAccounts
      }
      ]
    });
  }

  searchDetails(event: any, type: any, search: any) {
    if (event.keyCode == 13) {
      if (type == 'address') {
        if (search.length == 34) {
          this.router.navigate(['/account-details/', search])
        }
        else {
          this.alert.error('Search not found')
        }
      }
      else if (type == 'transHash') {
        if (search.length == 64) {
          this.router.navigate(['/trans-details/', search])
        }
        else {
          this.alert.error('Search not found')
        }
      }
      else if (type == 'blockNumber') {
        if (search.length == 7) {
          this.router.navigate(['/tag/', type, search])
        }
        else {
          // this.alert.error('Search not found')
          this.router.navigate(['/tag/', type, search])

        }
      }
      else if (type == undefined && search.includes('00000000')) {
        this.router.navigate(['/block-hash', search])
      }
      else if (type == 'token') {
        this.token_name = search
        if(this.token_name == 'ABC10'){
          this.router.navigate(['contracts-triggers', this.token_name,'1000001'])
        }
      }
      else if (type == undefined && search.length == 34 && this.searchType != 'Contracts' ) {
        this.router.navigate(['/account-details', search])

      }
      else if (type == undefined && search.length == 34 && this.searchType == 'Contracts' ) {
        this.router.navigate(['/contract-methods', search])
      }
      else if (type == undefined && search.length == 64) {
        this.router.navigate(['/trans-details', search])
      }
      else if (type == undefined && search.length <= 7) {
        this.router.navigate(['/tag/', 'allFilters', search])
      }
      else {
        this.searchobj = {}
        this.alert.error('Search not found')
      }
    }
  }

  getPriceDetails() {
    this.conn.postUrl('adminNew/getSastanaVolume', {}).subscribe((res: any) => {
      this.sastanaPrice = res.data[3].value
      this.marketCap = res.data[2].value
      this.volume = res.data[1].value
    })
  }

  SrInfo() {
    this.conn.getUrl('superRep/getSrDetails').subscribe((res: any) => {
      this.srCounts = res.data[0];
          });
  }

  getnextmaintenancetime() {
    this.conn.postUrl('contract/getTime', {}).subscribe((res: any) => {
      this.nextRound = res.data
    });
  }

  calculateTimeRemaining() {
    const currentTime = new Date().getTime();
    const timeDifference = this.nextRound - currentTime
    if (timeDifference > 0) {
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setTimeout(() => {
        this.calculateTimeRemaining();
      }, 1000);
    } else {
    }
  }
  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }

  removeSpace(event: any) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }
}
